import { http } from "../../../shared/api/http"

type LoginPayload = {
  email: string
  password: string
}

export const loginApi = (data: LoginPayload) => {
  return http.post("api/auth/login/email", data)
}

export type RegisterEmailPayload = {
  email: string
  password: string
  phone_number: string
  referral_click_token: string
}

export type RegisterEmailResponse = {
  user_id: string
  email: string
  message: string
}

export const registerEmailApi = (data: RegisterEmailPayload) => {
  return http.post<RegisterEmailResponse>("api/auth/register/email", data)
}

export type VerifyEmailPayload = {
  email: string
  code: string
}

export type VerifyEmailResponse = {
  user_id: string
  access_token: string
  refresh_token: string
}

export const verifyEmailApi = (data: VerifyEmailPayload) => {
  return http.post<VerifyEmailResponse>("api/auth/email/verify", data)
}

export const resendEmailCodeApi = (email: string) => {
  return http.post("api/auth/email/resend-code", { email })
}
